import React from 'react';
import { useSetResolved } from '@wearejh/m2-pwa-engine/lib/router/useSetResolved';

import { BranchesRoutes } from 'src/components/StoreLocator/BranchesRoutes';
import { fireGTMEvent } from 'src/features/analytics/hooks/useGtm';

import { Container, Wrapper } from '../../components/Layout';

import '../../scss/_root-component.scss';

export function StoreLocatorRoot() {
    useSetResolved();
    React.useEffect(() => {
        fireGTMEvent({ event: 'pageview', pageType: 'Store Locator Page' });
    }, []);
    return (
        <Wrapper variant="page-inner-with-breadcrumb">
            <Container>
                <BranchesRoutes />
            </Container>
        </Wrapper>
    );
}

export default StoreLocatorRoot;
